var map = {
	"./account.svg": 458,
	"./alertio.svg": 459,
	"./arrows-circle.svg": 460,
	"./arrows.svg": 461,
	"./bonus.svg": 462,
	"./cashbox.svg": 463,
	"./chevrons.svg": 464,
	"./common.svg": 465,
	"./controls.svg": 466,
	"./header.svg": 467,
	"./hint.svg": 468,
	"./icons.svg": 469,
	"./index-first-screen.svg": 470,
	"./input-messages.svg": 471,
	"./lobby.svg": 472,
	"./login.svg": 473,
	"./navigation.svg": 474,
	"./paper.svg": 475,
	"./profile.svg": 476,
	"./promotions.svg": 477,
	"./socials.svg": 478,
	"./support.svg": 479,
	"./themes.svg": 480,
	"./verification.svg": 481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;